import CalculateContainer from "./CalculateContainer";

export default function CalculatedFireFenceParams({ perimeterLength, waterVolume, runningTime, successProbability, handleOpenFireFenceParams }) {
  return (
    <CalculateContainer color="#3161ff" title="FireFence parameters" handleClick={handleOpenFireFenceParams}>
      <ul className="analysed-parameters">
        <li>Perimeter length: {perimeterLength} meters</li>
        <li>Water volume: {waterVolume} liters</li>
        <li>Running time required: {runningTime} minutes</li>
        <li>Success probability: {successProbability * 100}%</li>
      </ul>
    </CalculateContainer>
  );
}